// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {isFunction, noop} from 'lodash';

// Core Components
import AccordionButton from './accordion-button';

// Contexts
import {AccordionContext} from '../../contexts/accordion-context';

// Styles
import './accordion-panel.scss';

export default class AccordionPanel extends Component {
    state = {
        // eslint-disable-next-line react/destructuring-assignment
        expanded: this.props.defaultExpanded,
    };

    getClass() {
        const {expanded} = this.state;
        const {className} = this.props;

        return classnames(
            {
                'accordion-panel': true,
                'accordion-panel_expanded': expanded,
            },
            className
        );
    }

    isExpanded = () => {
        const {expanded} = this.state;
        const {recordId} = this.props;
        const {isForceExpanded} = this.context;

        return expanded || (isFunction(isForceExpanded) && isForceExpanded(recordId));
    };

    togglePanel = (event) => {
        const {expanded} = this.state;
        const {onChange = noop} = this.props;

        event && event.preventDefault && event.preventDefault();

        this.setState({expanded: !expanded});
        onChange(!expanded);
    };

    renderDetails() {
        const {animationCooldown, expanded} = this.state;
        const {detailsRenderer, recordId} = this.props;
        const {isForceExpanded} = this.context;
        let details = null;

        if (animationCooldown || expanded || (isFunction(isForceExpanded) && isForceExpanded(recordId))) {
            details = detailsRenderer();
        }

        return details;
    }

    renderToggle(position) {
        const {togglePosition = 'right', toggleContent, disableDefaultToggle} = this.props;
        let toggle = null;
        let classes;

        if (togglePosition === position && !disableDefaultToggle) {
            classes = classnames({
                'accordion-panel--toggle-right': position === 'right',
                'accordion-panel--toggle-left': position === 'left',
            });
            toggle = (
                <AccordionButton className={classes} iconPosition={togglePosition}>
                    {toggleContent}
                </AccordionButton>
            );
        }

        return toggle;
    }

    render() {
        const {children} = this.props;

        return (
            <AccordionContext.Provider
                value={{
                    isExpanded: this.isExpanded,
                    togglePanel: this.togglePanel,
                }}
            >
                <div className={this.getClass()}>
                    {this.renderToggle('left')}
                    {children}
                    {this.renderToggle('right')}
                    <div className="accordion-panel--details-container">
                        <div className="accordion-panel--details-animation">{this.renderDetails()}</div>
                    </div>
                </div>
            </AccordionContext.Provider>
        );
    }
}

AccordionPanel.contextType = AccordionContext;

AccordionPanel.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    defaultExpanded: PropTypes.bool,
    detailsRenderer: PropTypes.func.isRequired,
    disableDefaultToggle: PropTypes.bool,
    onChange: PropTypes.func,
    recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    toggleContent: PropTypes.node,
    togglePosition: PropTypes.oneOf(['left', 'right']),
};
